var map = {
	"./de.json": 276685,
	"./en.json": 89197,
	"./es.json": 560197,
	"./fr.json": 668820,
	"./it.json": 304371,
	"./ja.json": 690910,
	"./ko.json": 694819,
	"./pl.json": 307776,
	"./pt.json": 803834,
	"./ru.json": 583411,
	"./uk.json": 34684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 678366;